// AnalysisResult.jsx
import React from 'react';
import './AnalysisResult.css';
import HealthScore from './results/HealthScore';
import NutritionBreakdown from './results/NutritionBreakdown';
import IngredientsList from './results/IngredientsList';
import InsightsSection from './results/InsightsSection';
import HealthImplications from './results/HealthImplications';
import AlternativesSection from './results/AlternativesSection';
import AllergensWarning from './results/AllergensWarning';
import DietCompatibility from './results/DietCompatibility';
import ProcessingLevelInfo from './results/ProcessingLevelInfo';
import EnvironmentalImpact from './results/EnvironmentalImpact';
import RadarChart from './results/RadarChart';
import GoalAlignment from './results/GoalAlignment';         // <-- IMPORT
import RestrictionFlags from './results/RestrictionFlags';   // <-- IMPORT

const AnalysisResult = ({ data }) => {
  if (!data) {
    // Handle case where data might be null or undefined initially
    return <div className="results-container text-center p-5">Loading analysis results...</div>;
  }

  return (
    <div className="results-container">
      {/* Optional: Keep productName if it's not part of HealthScore or other main cards */}
      <h2 className="results-title mb-4 text-center display-6">{data.productName || "Food Analysis"}</h2>

      <HealthScore rating={data.rating} explanation={data.ratingExplanation} />
      <NutritionBreakdown nutrition={data.nutritionEstimate} />
      <IngredientsList ingredients={data.ingredients} />
      <InsightsSection insights={data.insights} />
      <HealthImplications implications={data.healthImplications} />
      <AlternativesSection alternatives={data.alternatives} />
      <AllergensWarning allergens={data.allergens} />
      <DietCompatibility compatibility={data.dietCompatibility} />
      <ProcessingLevelInfo processing={data.processingLevel} />
      <EnvironmentalImpact impact={data.environmentalImpact} />
      {/* Conditionally render GoalAlignment if data exists */}
      {data.goalAlignment && data.goalAlignment.length > 0 && (
        <GoalAlignment alignmentData={data.goalAlignment} />
      )}

      {/* Conditionally render RestrictionFlags if data exists OR always show (it has a "no flags" message) */}
      {/* Let's always render it, as it has a positive "no conflicts" message too */}
      <RestrictionFlags flags={data.restrictionFlags} />
      <RadarChart rating={data.rating} /> {/* Consider if radar chart needs more data points */}
    </div>
  );
};

export default AnalysisResult;